import changeIsLoading from '../../actions/changeIsLoading';
import initializeQuickActionsOptionViewState from '../../actions/quickActions/initializeQuickActionsOptionViewState';
import loadQuickActionsOption from '../../actions/quickActions/loadQuickActionsOption';
import { orchestrator } from 'satcheljs';

const loadQuickActionsOptionOrchestrator = orchestrator(
    loadQuickActionsOption,
    (actionMessage: {}) => {
        initializeQuickActionsOptionViewState();
        changeIsLoading(false);
    }
);

export default loadQuickActionsOptionOrchestrator;
